import React from 'react';
import { BrandsAPI } from '../../../../../../constructs/brands/interface';
import { useAPIContext } from '../../../../context/api';
import { Html5BannerData } from '../../../../types/banner/html5-banner';
import { VideoAPI } from '../../../../../../constructs/video-processing/interface';

export interface CreateHtmlBannerInput extends Html5BannerData {
  title: string;
  videoFile: File;
}

export const useCreateHtmlBanner = () => {
  const { callEndpoint } = useAPIContext();
  const [loading, setLoading] = React.useState(false);

  const createHtmlBanner = React.useCallback(
    async (payload: CreateHtmlBannerInput) => {
      try {
        setLoading(true);

        // Crear banner en DynamoDB
        const bannerRes = await callEndpoint<BrandsAPI, 'create-html-banner'>('brands', '/banners/html5', 'POST', {
          title: payload.title,
          videoData: {
            width: payload.width,
            height: payload.height,
            clickUrl: payload.clickUrl,
            exitId: payload.exitId,
            utm_source: payload.utm_source,
            utm_medium: payload.utm_medium,
            utm_campaign: payload.utm_campaign,
            utm_term: payload.utm_term,
            utm_content: payload.utm_content
          }
        });

        if (!bannerRes) {
          throw new Error('Failed to create banner');
        }

        //const uuid = `manual-uploads/${bannerRes.bannerId}`;
        const uuid = bannerRes.bannerId;
        const path = `/direct/${uuid}/video-mp4/video.mp4`;

        // Obtener URL prefirmada
        const uploadRes = await callEndpoint<VideoAPI, 'post'>('upload', path, 'POST', {
          fileType: 'video',
          fileExtension: '.mp4',
          optionalPrefix: 'brands'
        });

        if (!uploadRes || !uploadRes.uploadUrl) {
          throw new Error('Failed to get upload URL');
        }

        // Subir video directo a S3
        const uploadResponse = await fetch(uploadRes.uploadUrl, {
          method: 'PUT',
          body: payload.videoFile,
          headers: {
            'Content-Type': 'video/mp4'
          }
        });

        if (!uploadResponse.ok) {
          throw new Error(`S3 upload failed: ${uploadResponse.status}`);
        }

        return {
          bannerId: bannerRes.bannerId,
          cdnUrl: bannerRes.cdnUrl
        };
      } catch (error) {
        console.error('[useCreateHtmlBanner] Error:', error);
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [callEndpoint]
  );

  return {
    createHtmlBanner,
    loading
  };
};
